<template>
  <t-report-generate
      v-model="form"
      sub-validation-tag="sub-place-report-qrcode-pimaco4083-enterprise"
      default-pdf
      enable-generate-pdf
      help="Utilize uma folha no padrão Pimaco 4083 (Carta) para impressão no formato correto"
      origin="Teste de Origem"
      button-title="QR Code Pimaco 4083"
      :relation-key="form.checklistId"
      java-report
      title="QR Code Pimaco 4083">

    <template #default="{status}">


      <t-input-code-label :command="'insert'" required :status="status" enterprise
                          v-model="form.enterpriseId"/>


      <b-form-checkbox class="mt-2 mb-2" v-model="form.logoEnable" switch>
        Inserir logomarca?
      </b-form-checkbox>

    </template>



  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportQRCodeA4Enterprise',
  data() {
    return {
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        enterpriseId: 0,
        logoEnable: true,
      },
      checklistOptions: [],
    }
  },
  props: {},
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


    },



  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
